import { Typography } from '@atlas-metrics/design-system';
import { Trans, useTranslation } from 'next-i18next';
import React from 'react';

import IconCircle from './ui/IconCircle';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className='flex h-screen flex-col items-center justify-center'>
      <IconCircle
        iconClassName='text-ds-yellow-600'
        icon='icon-warning'
        className='mb-8 bg-ds-yellow-50'
      />
      <Typography variant='h4' className='mb-4 tracking-wide'>
        {t('not-found.title')}
      </Typography>
      <Typography variant='body-l' className='text-center text-ds-grey-700'>
        <Trans i18nKey='not-found.description' />
      </Typography>
    </div>
  );
}
